import { TranRecordModel } from "./tran-record.model"

export class BuildTransactModel {
    lngClientNo: number
    lngPetNo: number
    intCodeNo: number
    intCodeType: number
    strStatus: string
    strReqEmp: string
    intEmpNo: number
    Trans: TranRecordModel[]
    intTotalIdx: number
    strCodeName: string
    lngSupSeq: number
    intIndex: number
    strFix: string
    sglPrice: number
    intClinicNo: number
    linkDescription: string
    constructor(
        lngClientNo: number,
        lngPetNo: number,
        intCodeNo: number,
        intCodeType: number,
        strStatus: string,
        strReqEmp: string,
        intEmpNo: number,
        Trans: TranRecordModel[],
        intTotalIdx: number,
        strCodeName: string,
        lngSupSeq: number,
        intIndex: number,
        strFix: string,
        sglPrice: number,
        intClinicNo: number,
        linkDescription: string
    ) {
        this.lngClientNo = lngClientNo
        this.lngPetNo = lngPetNo
        this.intCodeNo = intCodeNo
        this.intCodeType = intCodeType
        this.strStatus = strStatus
        this.strReqEmp = strReqEmp
        this.intEmpNo = intEmpNo
        this.Trans = Trans
        this.intTotalIdx = intTotalIdx
        this.strCodeName = strCodeName
        this.lngSupSeq = lngSupSeq
        this.intIndex = intIndex
        this.strFix = strFix
        this.sglPrice = sglPrice
        this.intClinicNo = intClinicNo
        this.linkDescription = linkDescription
    }
}